import { render, staticRenderFns } from "./OurDXBankSolutionsComponent.vue?vue&type=template&id=174725fc&scoped=true&"
import script from "./OurDXBankSolutionsComponent.vue?vue&type=script&lang=js&"
export * from "./OurDXBankSolutionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./OurDXBankSolutionsComponent.vue?vue&type=style&index=0&id=174725fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174725fc",
  null
  
)

export default component.exports